import { processNodeAndPermissions } from "../../../helper/com-helper";
import { DSAI } from "./DSAI";
import { SNOE } from "./SNOE";
import { SS } from "./SS";

const IOP_OBJECT = {
    name: "Integrated Operations Planning",
    route: "/snoe",
    permissions: [],
    child: {
        "S&OE": SNOE,
        "Demand Sensing": DSAI,
        "Supply Sensing": SS
    },
};

processNodeAndPermissions(IOP_OBJECT);
export const IOP = IOP_OBJECT;
